// extracted by mini-css-extract-plugin
export default {"root":"Header_root__wt6yp","logo":"Header_logo__exao9"};